import type { ReleaseNotesDataObject } from './service';

export type ReleaseNotes = {
  id: string;
  text: string;
  versionValue: string;
};

export const createReleaseNotes = (releaseNotes: ReleaseNotesDataObject): ReleaseNotes => ({
  id: releaseNotes._id,
  text: releaseNotes.text,
  versionValue: releaseNotes.versionValue,
});
